import { Typography } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";

export type EventCardTitleProps = { title: string }

const styles: SxProps<Theme> = {
    whiteSpace: "normal",
    flex: 1,
    display: "-webkit-box",
    WebkitLineClamp: 5,
    WebkitBoxOrient: "vertical",
    textOverflow: "ellipsis",
    overflow: "hidden",
};

export const EventCardTitle: React.FC<EventCardTitleProps> = ({ title }) => {
    return (
        <Typography variant="h7" color="text.primary" sx={styles} data-testid="event-card-title">
            {title}
        </Typography>
    );
};
